<script lang="ts" setup>
import { rankingConfig as rocnovelConfig } from './configs/rocnovel'
import { rankingConfig as ocereadConfig } from './configs/oceread'
import { rankingConfig as ficmoonConfig } from './configs/ficmoon'
import { rankingConfig as novelarcConfig } from './configs/novelarc'
import { rankingConfig as storyellaConfig } from './configs/storyella'
import { rankingConfig as silktaleConfig } from './configs/silktale'
import { rankingConfig as pearlaConfig } from './configs/pearla'
import { rankingConfig as fictoraConfig } from './configs/fictora'
import { rankingConfig as marinovelConfig } from './configs/marinovel'
import RankingPageDefault from './components/RankingPage.default.vue'
import RankingPageFicmoon from './components/RankingPage.ficmoon.vue'
import RankingPageNovelarc from './components/RankingPage.novelarc.vue'
import { loadBrandComponent, loadBrandConfig } from '@/utils/loadBrandConfig'

defineProps<{
  columnId: string
}>()

// 🔥 加载当前品牌配置（构建时 tree-shaking）
const config = loadBrandConfig({
  rocnovel: rocnovelConfig,
  oceread: ocereadConfig,
  ficmoon: ficmoonConfig,
  novelarc: novelarcConfig,
  storyella: storyellaConfig,
  silktale: silktaleConfig,
  pearla: pearlaConfig,
  fictora: fictoraConfig,
  marinovel: marinovelConfig,
})

// 🔥 加载当前品牌组件（rocnovel 和 oceread 共用 default，ficmoon 和 novelarc 用专属组件）
const RankingPage = loadBrandComponent({
  rocnovel: RankingPageDefault,
  oceread: RankingPageDefault,
  ficmoon: RankingPageFicmoon,
  novelarc: RankingPageNovelarc,
  storyella: RankingPageNovelarc,
  silktale: RankingPageNovelarc,
  pearla: RankingPageNovelarc,
  fictora: RankingPageFicmoon,
  marinovel: RankingPageDefault,
})
</script>

<template>
  <div>
    <!-- 🔥 品牌专属页面组件 -->
    <RankingPage :column-id="columnId" :config="config" />
  </div>
</template>
